// extracted by css-extract-rspack-plugin
export default {"text":"OcPvVjziQx0NLexo__text___"};